<template>
    <div id="plan">
        <header>
            <img :src="nameBg" alt="bgGetting" class="header-image">
            <div class="link">
                <select v-model="pathPlan" class="form-control" @change="changeRout">
                    <option value="getting-to-mongolia">Getting to mongolia</option>
                    <option value="travel-around">Travel around</option>
                    <option value="customs-culture">Customs & Culture</option>
                    <option value="practical-information">Practical Information</option>
                </select>
            </div>
        </header>
        <router-view @changePage="changepage"></router-view>
        <FooterDiv/>
    </div>
</template>

<script>
import bg01 from '../../assets/img/bg-getting.jpg'
import bg02 from '../../assets/img/bg-travelaround.jpg'
import bg03 from '../../assets/img/bg-customs.jpg'
import bg04 from '../../assets/img/bg-practical.jpg'
import FooterDiv from '@/components/Footer'

export default {
    name : 'plan',
    components: {
        FooterDiv
    },
    data() {
        return {
            bg : {
                'getting-to-mongolia' : {
                    bgImg : bg01
                },
                'travel-around' : {
                    bgImg : bg02
                },
                'customs-culture' : {
                    bgImg : bg03
                },
                'practical-information' : {
                    bgImg : bg04
                },
            },
            nameBg : "",
            pathPlan : ""
        }
    },
    mounted() {
        this.pathPlan = this.$route.name;
        this.nameBg = this.bg[this.pathPlan].bgImg
    },
    methods: {
        changeRout() {
            this.$router.push({path:'/plan/' + this.pathPlan })
            this.nameBg = this.bg[this.pathPlan].bgImg
        },
        changepage(number) {
            if (number) {
                this.pathPlan = this.$route.name;
                this.nameBg = this.bg[this.pathPlan].bgImg
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    #plan {
        padding-top: 52px;

        .header-image {
            width: 100%;
            height: auto;
        }

        .link {
            padding: 25px 22px;
        }
    }
</style>


